import { Scene as THREESCene } from 'three';

class Scene extends THREESCene {
}

const sc = new Scene();

window.scene = sc;

export default sc;
